import { Component } from "vue-property-decorator";
import Template from "./template.vue";
import FormsMixin from "@/mixins/FormsMixin";
import { Action } from 'vuex-class';
import Header from "@/components/Header/components";

@Component({
  mixins: [Template],
  components: {
    Header,
  },
})
export default class Inicio extends FormsMixin {
  @Action("getComprasMesActual", { namespace: "general" }) getComprasMesActual!: Function;

  public dias: Array<string> = [];
  public value: Array<number> = [];
  public comprasMesActual: Record<string, string> = {};

  async mounted(){
    await this.getComprasMesActual()
    .then((result: Record<string, string>) => {
      this.comprasMesActual = result;
      this.pushArrayDiasMesActual();
    });
  }

  pushArrayDiasMesActual(){
    if(this.comprasMesActual!=undefined){
      const qttDias = this.getDiasMesActual();
      this.dias = [];
      for (let index = 0; index < qttDias; index++) {
        this.dias.push(index.toString());
        this.value.push(Number.parseInt(this.comprasMesActual[index]));
      }
    }
  }

  getDiasMesActual(){
    const fecha = new Date();
    return new Date(fecha.getFullYear(), fecha.getMonth(), 0).getDate();
  }
}
